<template>
    <div id="app">
        <FullSwiper v-if="showMask" @showFullSwiper="showFullSwiper"></FullSwiper>
        <router-view @showFullSwiper="showFullSwiper"></router-view>
    </div>
</template>

<script>
import FullSwiper from "@/components/FullSwiper2";
export default {
    data(){
        return {
           showMask:false 
        }
    },
    components: {
        FullSwiper,
    },
    methods: {
        showFullSwiper(status){
            if(status==undefined){
                this.showMask=!this.showMask
            }else{
                this.showMask=status
            }
        }
    }
}
</script>
<style lang="scss" >

</style>
